import React from 'react'
import { IspirazionePageConfig } from '../configuration'
import VisibilitySensor from '../VisibilitySensor'
import Vimeo from "@u-wave/react-vimeo";
import AssignId from '../AssignId'
import Container from '../Container'
import styles from './Ispirazione.module.sass'

export default function Ispirazione() {
    const showTitle = false;
    return (
        <Container>
            <div className={styles.root}>
                <AssignId
                    absolute
                    y='-120px'
                    yMobile='-80px'
                    id={IspirazionePageConfig.id}
                />
                <div className={"scroll-fadein"}>
                    <h1 className={`${styles.title}`}>{IspirazionePageConfig.title}</h1>
                    <div className={`${styles.description}`} dangerouslySetInnerHTML={{ __html: `<p>${IspirazionePageConfig.description}</p>` }}>
                    </div>
                </div>
                <VisibilitySensor index={1} />
                <div className={`${styles.iframeWrap} scroll-fadein-late`} >
                    <Vimeo
                        className='styles.iframe'
                        video={IspirazionePageConfig.videoId}
                        responsive
                        paused
                        color={IspirazionePageConfig.videoColor}
                        showTitle={showTitle}
                        showByline={showTitle}
                        showPortrait={showTitle}
                    />
                </div>
            </div>
        </Container>
    )
}